import axios from 'axios';
import {
	ENDPOINT_URL,
	GET_MULTI_PSK_LIST,
} from '../../../constants/commonConstants';
import {replaceResolvedEntities} from '../../core/resolvedEntityStore';
import {
	decodeAgentResponse,
	optionalText,
	rankLookupCandidates,
	responseRows,
} from '../../core/resolutionUtils';

/**
 * Normalize a Canvas Multi-PSK profile without exposing profile keys.
 * @param {object} item Canvas Multi-PSK row
 * @return {object|null} agent candidate
 */
function normalizeMultiPsk(item) {
	const id = item.psk_id ?? item.id;
	const name = item.psk_name ?? item.name;
	if (id == null || !name) return null;
	const safeId = String(id).trim();
	const safeName = String(name).trim();
	if (!safeId || !safeName) return null;
	return {
		entity_type: 'multi_psk',
		entity_id: safeId,
		name: safeName,
		site_id: null,
		site_name: null,
		security_type: null,
		status: optionalText(item.status),
		serial_no: null,
	};
}

/**
 * Resolve visible Multi-PSK profiles from the authenticated Canvas API.
 * @param {object} params resolver parameters
 * @return {Promise<{candidates: object[]}>} normalized candidates
 */
export async function resolveMultiPskProfiles(params = {}) {
	const query = String(params.query || '').trim();
	const requestedLimit = Number(params.limit);
	const limit = Number.isInteger(requestedLimit)
		? Math.min(Math.max(requestedLimit, 1), 25)
		: 5;
	const isTip = params.is_tip === true ? 1 : 0;
	const search = query
		? `&search=${encodeURIComponent(query)}`
		: '';
	const url = `${ENDPOINT_URL}${GET_MULTI_PSK_LIST}?limit=${limit}` +
		`&offset=0&isTip=${isTip}${search}`;
	const {data} = await axios.get(url);
	const rows = responseRows(decodeAgentResponse(data) || {});
	// Retained so the page can act on the row the agent names. The
	// table it lives in may still be loading when that command lands.
	replaceResolvedEntities('multi_psk', rows, (item) => item.psk_id ?? item.id);
	const candidates = rows.map(normalizeMultiPsk).filter(Boolean);
	return {
		candidates: query
			? rankLookupCandidates(candidates, query, limit)
			: candidates.slice(0, limit),
	};
}
